import { Router, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

declare module '@angular/router' {
  interface ActivatedRoute {
    parametro(this: ActivatedRoute, param: string): string;
    /**
     * Retorna a url base, sempre para o ambiente de catalogo ou compras
     */
    baseUrl(this: ActivatedRoute): string;
    obterDados<T>(this: ActivatedRoute): T;
  }

  interface ActivatedRouteSnapshot {
    parametro(this: ActivatedRouteSnapshot, param: string): string;
  }

  interface Router {
    navegar(this: Router, rota: string): Promise<boolean>;
    navegarComDados(this: Router, rota: string, dados: any): Promise<boolean>;
  }
}

ActivatedRoute.prototype.parametro = function (this: ActivatedRoute, param: string): string {
  function getParametro(rotaAtual: ActivatedRoute[], nomeParametro: string): string {
    let parametro: string = null;
    rotaAtual.forEach(rota => {
      if (rota.children.length > 0) {
        parametro = getParametro(rota.children, nomeParametro);
      }
      if (!parametro) {
        parametro = rota?.snapshot?.paramMap?.get(nomeParametro) ?? '';
      }
    });
    return parametro;
  }
  return getParametro(this.root.children, param);
};

ActivatedRouteSnapshot.prototype.parametro = function (this: ActivatedRouteSnapshot, param: string): string {
  function getParametro(rotaAtual: ActivatedRouteSnapshot[], nomeParametro: string): string {
    let parametro: string = null;
    rotaAtual.forEach(rota => {
      if (rota.children.length > 0) {
        parametro = getParametro(rota.children, nomeParametro);
      }
      if (!parametro) {
        parametro = rota?.paramMap?.get(nomeParametro) ?? '';
      }
    });
    return parametro;
  }
  return getParametro(this.root.children, param);
};

ActivatedRoute.prototype.obterDados = function <T>(this: ActivatedRoute): T {
  const jsonTexto = this.snapshot.queryParamMap.get('data');
  let objeto: T;
  if (jsonTexto) {
    objeto = (JSON.parse(jsonTexto) as T);
  }
  return objeto;
};

Router.prototype.navegar = function (this: Router, rota: string): Promise<boolean> {
  return this.navigate([`${rota}`]);
};

Router.prototype.navegarComDados = function (this: Router, rota: string, dados: any): Promise<boolean> {
  return this.navigate([`${rota}`], {
    queryParams: {
      data: JSON.stringify(dados)
    }
  });
};


